import TrendTimelineContainer from 'containers/chart/TrendTimelineContainer';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { Grid, Segment } from 'semantic-ui-react';
import ChartKeyContainer from '../../../containers/chart/ChartKeyContainer';
import { TimeSeriesPlotContainer } from '../../../containers/chart/TimeSeriesChartContainer';
import { CHART_TYPE, INVERTED_THEME } from '../../../utils/constants';
import styles from './TimeSeriesChart.styles';

const TimeSeriesChart = injectIntl(({
  isLoading,
  trendTimelineHeight,
  chartType
}) => (
  <Grid
    stackable
    className='no-padding full-height'>
    <Grid.Row>
      <Grid.Column
        mobile={16}
        tablet={5}
        computer={5}
        largeScreen={4}
        widescreen={3}>
        <ChartKeyContainer
          chartType={chartType}
          showKeyColours
          showFeaturesToggle />
      </Grid.Column>
      <Grid.Column
        mobile={16}
        tablet={11}
        computer={11}
        largeScreen={12}
        widescreen={13}>
        <div style={styles.timelineWrapper}>
          <TrendTimelineContainer chartType={chartType} />
        </div>
        <Segment
          className='transparent-background'
          inverted={INVERTED_THEME}
          loading={isLoading}
          style={isLoading
            ? styles.plotSegmentLoading(trendTimelineHeight)
            : styles.plotSegment(trendTimelineHeight)}>
          <TimeSeriesPlotContainer chartType={chartType} />
        </Segment>
      </Grid.Column>
    </Grid.Row>
  </Grid>
));

TimeSeriesChart.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  chartType: PropTypes.oneOf(_.values(CHART_TYPE)).isRequired
};

TimeSeriesChart.displayName = 'TimeSeriesChart';

export default TimeSeriesChart;